(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Thumbnail rail: click a thumb → swap the main cover image
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const cover = gallery.querySelector('[data-product-cover]');
    const thumbs = gallery.querySelectorAll('[data-product-thumb]');
    if (!cover || thumbs.length === 0) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.coverSrc;
        const srcset = thumb.dataset.coverSrcset;
        if (!src) return;
        cover.src = src;
        if (srcset) cover.srcset = srcset;
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  // Variant picker: change a swatch → resolve matching variant, update id +
  // price + button + cover (when the variant carries its own featured_image)
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const optionsRoot = section.querySelector('[data-product-options]');
    const variantsScript = section.querySelector('[data-product-variants]');
    if (!optionsRoot || !variantsScript) return;

    let variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }
    if (!Array.isArray(variants)) return;

    const idInput = section.querySelector('[data-variant-id-input]');
    const priceEl = section.querySelector('[data-variant-price]');
    const compareEl = section.querySelector('[data-variant-compare-price]');
    const cover = section.querySelector('[data-product-cover]');
    const thumbs = section.querySelectorAll('[data-product-thumb]');
    const addBtn = section.querySelector('[data-add-to-cart]');
    const addBtnText = section.querySelector('[data-add-to-cart-text]');

    function selectedOptions() {
      return Array.from(optionsRoot.querySelectorAll('input[type="radio"]:checked'))
        .map((input) => input.value);
    }

    function findVariant() {
      const sel = selectedOptions();
      return variants.find((v) =>
        Array.isArray(v.options) &&
        v.options.length === sel.length &&
        v.options.every((opt, i) => opt === sel[i])
      );
    }

    function updateSwatchHighlight() {
      optionsRoot.querySelectorAll('.product__swatch').forEach((label) => {
        const input = label.querySelector('input[type="radio"]');
        label.classList.toggle('is-selected', !!input && input.checked);
      });
    }

    function syncCoverToThumbs(src) {
      thumbs.forEach((t) => {
        t.classList.toggle('is-active', t.dataset.coverSrc === src);
      });
    }

    function applyVariant(variant) {
      if (!variant) return;

      if (idInput) idInput.value = variant.id;

      if (priceEl) priceEl.textContent = variant.price_formatted;
      if (compareEl) {
        if (variant.compare_at_price_formatted) {
          compareEl.textContent = variant.compare_at_price_formatted;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
      }
      if (addBtnText) {
        const label = addBtn ? addBtn.dataset.buttonLabel : 'Add to cart';
        addBtnText.textContent = variant.available
          ? label + ' — ' + variant.price_formatted
          : 'Sold out';
      }

      if (variant.image && cover) {
        cover.src = variant.image.src;
        if (variant.image.srcset) cover.srcset = variant.image.srcset;
        syncCoverToThumbs(variant.image.src);
      }
    }

    optionsRoot.addEventListener('change', (e) => {
      if (e.target && e.target.matches('input[type="radio"]')) {
        updateSwatchHighlight();
        applyVariant(findVariant());
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  document.querySelectorAll('[data-related-products]').forEach((host) => {
    const url = host.dataset.url;
    if (!url) return;

    fetch(url)
      .then((res) => (res.ok ? res.text() : Promise.reject(res.status)))
      .then((html) => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        const fetched = tmp.querySelector('[data-related-products]');
        if (!fetched) {
          host.hidden = true;
          return;
        }
        // If the recommendations response carries no products, hide the section.
        const grid = fetched.querySelector('.related-products__grid');
        if (!grid || grid.children.length === 0) {
          host.hidden = true;
          return;
        }
        host.innerHTML = fetched.innerHTML;
      })
      .catch(() => {
        host.hidden = true;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTimeline(section) {
      if (section.dataset.tlInit === '1') return;
      section.dataset.tlInit = '1';

      var rail = section.querySelector('[data-tl-rail]');
      var prev = section.querySelector('[data-tl-prev]');
      var next = section.querySelector('[data-tl-next]');
      if (!rail || !prev || !next) return;

      var drag = { down: false, startX: 0, startScroll: 0, moved: false };

      function syncArrows() {
        prev.disabled = rail.scrollLeft <= 4;
        next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 4;
      }

      function nudge(dir) {
        var atStart = rail.scrollLeft <= 4;
        var atEnd = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 4;
        if (dir < 0 && atStart) return;
        if (dir > 0 && atEnd) return;
        var step = Math.min(rail.clientWidth * 0.7, 560);
        rail.scrollBy({ left: dir * step, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { nudge(-1); });
      next.addEventListener('click', function () { nudge(1); });
      rail.addEventListener('scroll', syncArrows, { passive: true });
      window.addEventListener('resize', syncArrows);

      rail.addEventListener('pointerdown', function (e) {
        drag = { down: true, startX: e.clientX, startScroll: rail.scrollLeft, moved: false };
        if (rail.setPointerCapture) rail.setPointerCapture(e.pointerId);
      });
      rail.addEventListener('pointermove', function (e) {
        if (!drag.down) return;
        var dx = e.clientX - drag.startX;
        if (Math.abs(dx) > 4) drag.moved = true;
        rail.scrollLeft = drag.startScroll - dx;
      });
      function endDrag(e) {
        drag.down = false;
        if (rail.releasePointerCapture && e.pointerId != null) {
          try { rail.releasePointerCapture(e.pointerId); } catch (_) {}
        }
      }
      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);

      rail.addEventListener('click', function (e) {
        if (drag.moved) {
          e.preventDefault();
          e.stopPropagation();
          drag.moved = false;
        }
      }, true);

      syncArrows();
    }

    function initAll() {
      document.querySelectorAll('[data-tl-section]').forEach(initTimeline);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
